<template>
  <b-row>
    <b-col cols="12">
      <b-row>
        <b-col cols="12" class="my-2">
          <b-row class="my-2 mx-1">
            <b-col cols="2">
              <b-form-group label="Certificate Number" class="mb-0 text-xs text-gray">
                <b-form-input
                  class="text-sm noFocus"
                  v-model="certificateNumber"
                  type="text"
                  placeholder="Certificate Number"
                  required
                  v-on:keyup.enter="fetch">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Title" class="mb-0 text-xs text-gray">
                <b-form-input
                  class="text-sm noFocus"
                  v-model="title"
                  type="text"
                  placeholder="Title"
                  required
                  v-on:keyup.enter="fetch">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Date registered from" class="mb-0 text-xs text-gray">
                <b-form-input
                  class="text-gray text-sm noFocus"
                  style="margin-top: 1px; padding:6px 5px;"
                  v-model="startDate"
                  type="date"
                  required
                  v-on:change="fetch">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Date registered to" class="mb-0 text-xs text-gray">
                <b-form-input
                  class="text-gray text-sm noFocus"
                  style="margin-top: 1px; padding:6px 5px;"
                  v-model="endDate"
                  type="date"
                  required
                  v-on:change="fetch">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="1">
              <b-form-group label="Limit" class="mb-0 text-xs text-gray">
                <b-form-select v-model="limit" class="w-full text-xs form-select border-0 paginate-details mt-1" v-on:change="fetch">
                  <b-select-option value="15">15</b-select-option>
                  <b-select-option value="20">20</b-select-option>
                  <b-select-option value="50">50</b-select-option>
                  <b-select-option value="100">100</b-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group label="Page" class="mb-0 text-xs text-gray invisible">
                <span>Page</span>
              </b-form-group>
              <p class="paginate-details text-center text-xs font-bold mt-1">
                <span>{{((currentPage - 1) * limit) + 1}}</span> -
                <span v-if="limit > copyrights.length ">{{pagination.totalElements}}</span>
                <span v-else>{{currentPage * limit}}</span>
                of {{pagination.totalElements}}
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <div class="mx-auto">
        <b-progress value="100" v-if="loading" variant="#007ac5" height="0.2rem" animated></b-progress>
      </div>
      <b-row>
        <b-col cols="12">
          <table class="min-w-full leading-normal">
            <thead>
            <tr class="border-b border-t border-grey">
              <th class="t-header">#</th>
              <th class="t-header">Certificate No.</th>
              <th class="t-header">Title</th>
              <th class="t-header text-center">Registration Date</th>
              <th class="t-header text-center">Status</th>
              <th class="t-header text-center">Action</th>
            </tr>
            </thead>

            <tbody>
            <tr :class="[(idx%2) ? rows.even : rows.odd]" v-for="(item, idx) in copyrights" :key="idx">
              <td class="t-body">{{(currentPage - 1) * limit + idx + 1}}</td>
              <td class="t-body text-blue font-bold">
                <span class="cursor-pointer hover:text-blue-dark hover:underline" @click="viewDetails(item.trackingNumber || item.trackingNo)">
                  {{item.certificateNumber || 'N/A'}}
                </span>
              </td>
              <td class="t-body font-bold">
                <span>{{item.title || item.newName}}</span>
              </td>
              <td class="t-body text-center">
                <span>{{dateFormat(item.createdAt || item.approvalDate)}}</span>
              </td>
              <td class="t-body text-center text-capitalize">
                <span class="text-green text-xs font-bold">
                  {{item.status ? item.status.toLowerCase().replaceAll("_", " ") : 'Registered'}}
                </span>
              </td>
              <td class="text-center">
                <button class="bg-blue text-white rounded-sm px-2 py-1 text-xs hover:bg-blue-dark" @click="viewDetails(item.trackingNumber || item.trackingNo)">
                  View
                </button>
              </td>
            </tr>
            <tr v-if="copyrights.length === 0">
              <td colspan="6" class="bg-inertgrey text-center py-2">
                <span class="text-sm">No results found</span>
              </td>
            </tr>
            <tr v-if="hasError">
              <td colspan="6" class="bg-red text-center py-1 text-white">
                <p class="text-sm">Failed to load registry records, Try again later.</p>
                <p class="text-sm">{{errorMessage}}</p>
                <p class="text-sm">
                  <button class="bg-white text-red px-2 rounded-sm" @click="fetch">Reload <b-spinner v-if="loading" small></b-spinner></button>
                </p>
              </td>
            </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <b-row class="mx-1" v-if="pagination.totalPages > 1">
        <b-col cols="1">
          <button @click="previous" :class="(currentPage > 1) ? 'paginate-btn' :'inert-btn'">Previous</button>
        </b-col>
        <b-col cols="1">
          <b-row>
            <b-col cols="12">
              <p class="paginate-details text-center">
                <b-badge class="bg-blue text-white">
                  {{currentPage}}/{{pagination.totalPages}}
                </b-badge>
              </p>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="1" >
          <button @click="next" :class="(currentPage < pagination.totalPages) ? 'paginate-btn' :'inert-btn'">Next</button>
        </b-col>
        <b-col cols="6"></b-col>
        <b-col cols="1">
          <b-form-select v-model="limit" class="w-full text-xs form-select border-0 paginate-details" v-on:change="fetch">
            <b-select-option value="15">15</b-select-option>
            <b-select-option value="20">20</b-select-option>
            <b-select-option value="50">50</b-select-option>
            <b-select-option value="100">100</b-select-option>
          </b-form-select>
        </b-col>
        <b-col cols="2">
          <b-row>
            <b-col class="mx-auto">
              <p class="paginate-details text-center text-xs font-bold">
                <span>{{((currentPage - 1) * limit) + 1}}</span> -
                <span v-if="limit > copyrights.length ">{{pagination.totalElements}}</span>
                <span v-else>{{currentPage * limit}}</span>
                of {{pagination.totalElements}}
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import router from "@/router";

export default {
  name: "CopyrightRegistryList",
  data() {
    return {
      loading: false,
      currentPage: 1,
      limit: 15,
      copyrights: [],
      pagination: {
        totalElements: 0,
        totalPages: 0
      },
      rows: {
        odd: "border-t border-grey hover:bg-header_grey",
        even: "border-t border-grey bg-header_grey"
      },
      certificateNumber: "",
      title: "",
      startDate: null,
      endDate: null,
      hasError: false,
      errorMessage: null
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    ...mapActions(["fetchCopyrightRegistry"]),
    fetch() {
      let data = {
        page: this.currentPage,
        limit: this.limit,
        certificateNumber: this.certificateNumber,
        title: this.title,
        startDate: this.startDate ? moment(this.startDate).format('YYYY-MM-DD') : null,
        endDate: this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : null,
      };
      this.loading = true;
      this.hasError = false;
      this.fetchCopyrightRegistry(data);
    },
    viewDetails(trackingNumber) {
      router.push("/home/registry/copyright/file-viewer/" + trackingNumber);
    },
    next() {
      if (this.currentPage < this.pagination.totalPages) {
        this.currentPage++;
        this.fetch();
      }
    },
    previous() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetch();
      } else {
        this.warningToast("Observation", "No more data to show");
      }
    },
    dateFormat(date) {
      if (!date) return "";
      return moment(date).format("DD-MM-YYYY");
    }
  },
  computed: {
    ...mapGetters(["getCopyrightRegistry", "getCopyrightRegistryError"])
  },
  watch: {
    getCopyrightRegistry(data) {
      this.loading = false;
      if (data && data.data) {
        this.copyrights = data.data.content || [];
        this.pagination = {
          totalPages: data.data.Pagination ? data.data.Pagination.totalPages : 0,
          totalElements: data.data.Pagination ? data.data.Pagination.totalRows : 0
        };
      } else {
        this.copyrights = [];
        this.pagination = {
          totalPages: 0,
          totalElements: 0
        };
      }
    },
    getCopyrightRegistryError(data) {
      this.loading = false;
      this.hasError = true;
      this.errorMessage = data ? data.message : "Error fetching registry records";
      this.errorToast("Error", this.errorMessage);
    }
  }
};
</script>

<style scoped>
@import "../../../../../assets/styles/table.css";

.paginate-details {
  @apply px-3 py-2 bg-white my-2 text-sm text-gray;
}

.paginate-btn {
  @apply px-3 py-2 bg-white border border-white my-2 text-sm text-blue w-full;
}

.paginate-btn:hover {
  @apply border border-blue text-blue rounded-sm;
}

.inert-btn {
  @apply px-3 py-2 bg-white my-2 text-sm text-grey w-full;
}
</style>
